import React, {
    useCallback, useEffect, useMemo, useState,
} from 'react';

import {
    Loader, Radio, SegmentedControl, Space, Title, SimpleGrid, Group,
} from '@mantine/core';
import { Button } from 'react-bootstrap';

import Fetcher from '../common/communicate';

const aclLabels = {
    admin_panel: 'Настройка прав',
    articles: 'Статьи',
    betakeys: 'Бетаключи',
    compilations: 'Подборки',
    files: 'Файлы',
    games: 'Игры',
    images: 'Галереи',
    mailing_lists: 'Рассылки Р1',
    mailing_lists_vkplay: 'Рассылки VKP',
    news: 'Новости',
    pockets: 'Карманы',
    raw_html: 'Raw HTML',
    static_pages: 'Статичные материалы (GoF)',
    table_html: 'Таблицы',
    tags: 'Теги',
    ugc: 'UGC',
    reports: 'Отчёты',
};

export default function AdminRoles() {
    const [roles, setRoles] = useState([]);
    const [currentRole, setCurrentRole] = useState('0');

    const controls = useMemo(() => roles.map((role, i) => ({ value: i, label: role?.description })), [roles]);

    const handleRadioChange = useCallback((newValue, name) => {
        const clonedRoles = window.structuredClone(roles);

        clonedRoles[currentRole].acl[name] = newValue;

        setRoles(clonedRoles);
    }, [roles, currentRole, setRoles]);

    const renderAccess = useCallback(([name, value]) => (
        <Radio.Group
            key={name}
            label={aclLabels[name]}
            value={`${value}`}
            name={name}
            onChange={(newValue) => handleRadioChange(newValue, name)}
            sx={{
                label: { marginBottom: 0 },
            }}
        >
            <Group>
                <Radio value="0" label="Нет" />
                <Radio value="1" label="Чтение" />
                <Radio value="3" label="Запись" />
            </Group>
        </Radio.Group>
    ), [handleRadioChange]);

    function handleRoleChange(newRoleIndex) {
        setCurrentRole(`${newRoleIndex}`);
    }

    function handleRoleSave() {
        Fetcher(`admin/acl/roles/${roles[currentRole].id}`, 'PATCH', null, roles[currentRole]);
    }

    useEffect(() => {
        Fetcher('admin/acl/roles/', 'GET', (data) => {
            if (!data.results) {
                return;
            }

            setRoles(data.results);
        });
    }, []);

    if (!roles.length) {
        return null;
    }

    return (
        <div>
            <Title>Роли</Title>
            <Space h="md" />
            {roles.length ? (
                <>
                    <SegmentedControl
                        size="sm"
                        data={controls}
                        value={currentRole}
                        onChange={handleRoleChange}
                        sx={{
                            label: { marginBottom: 0 },
                        }}
                    />
                    <Space h="lg" />
                    <SimpleGrid
                        cols={3}
                        style={{ maxWidth: 900 }}
                    >
                        {Object.entries(roles[currentRole].acl).map((access) => renderAccess(access))}
                    </SimpleGrid>
                    <Space h="xl" />
                    <Button
                        onClick={handleRoleSave}
                    >
                        Сохранить роль
                    </Button>
                </>
            ) : (
                <Loader />
            )}
        </div>
    );
}
